/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb35Inputs */

const en__field_enum_pbs_fb35 = /** @type {(inputs: _Field_Enum_Pbs_Fb35Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 03 Faculty of Social Sciences`)
};

const de__field_enum_pbs_fb35 = /** @type {(inputs: _Field_Enum_Pbs_Fb35Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 03 Gesellschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "F 03 Faculty of Social Sciences" |
*
* @param {_Field_Enum_Pbs_Fb35Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb35 = /** @type {((inputs?: _Field_Enum_Pbs_Fb35Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb35Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb35(inputs)
	return de__field_enum_pbs_fb35(inputs)
});
export { _field_enum_pbs_fb35 as "_field_enum_PBS_FB3" }